export const EN = {
  translation: {
    Header: {
      TITLE: "header",
      AIM: "patissier portfolio",
      ABOUT_ME: "about me",
      SKILLS: "skills",
      CAKES: "cakes",
      CONTACT: "contact",
      MAIN: 'main'
    },
    HomePage: {
      TITLE: "home",
      Landing: {
        HELLO: "Hello! I am Alexandra, dedicated",
        PATISSIER: "Patissier",
        BRING_MAGIC:
          "In crafting desserts, I bring magic to the plate, turning sweets into unforgettable moments. With creativity and whimsy, my dishes enchant, each a captivating delight."
      },
      AboutMe: {
        TITLE:'Introduction',
        INTRODUCTION : "My life is like a multi-layered cake, where each layer represents a slice of passion, creativity, and continuous learning. Pastry isn't just a profession for me, but an artistic form of expression where my imagination can soar, creating smiles on people's faces with delicious flavors and shapes. But my creativity doesn't stop in the kitchen; painting and programming provide the other two foundational pillars. My love for learning drives me to constantly expand my knowledge and skills. There's always something to learn – new recipes, painting techniques, programming languages – and this thirst for knowledge keeps me alert and motivated.The importance of a calm, balanced lifestyle to me is like the sunshine on a relaxing afternoon. I strive for harmony in my daily life, to be at peace with my surroundings and myself. This inner peace and balance give me the strength and inspiration to give my best in everything I do. Everything I do is guided by passion and creativity. My passion for reading invites me on journeys to other worlds, where fantasy and sci-fi stories, as well as literary works and scientific knowledge, find their place. Currently, learning Italian allows me to broaden my horizons, discovering new cultures and perspectives. These values guide every aspect of my life, enabling me to live each day to the fullest."
      },
      Skills:{
        HUN:'hungarian',
        ENG:'english',
        ITA:'italian',
        GER:'german',
        HUN_LEV:'native',
        ENG_LEV:'C2',
        ITA_LEV:'beginner',
        COUNTER:{
          RECEIPES:'receipes',
          EXPERIENCE:'years of experience',
          COUNTRIES:"countries's desserts"
        },
        TECHNICAL_SKILLS:'Technial Skills',
        SOFT_SKILLS:'Soft Skills',
        LANGUAGES_SKILLS:'Languages',
        TECHNICAL:[
          'I have mastered various baking methods, including creaming, folding, whisking, and kneading. Additionally, I possess a deep understanding of oven temperatures, ensuring proper baking and consistency in pastry products.',
          'I pay meticulous attention to flavor combinations, consistently creating harmonious flavor profiles in desserts. Each dessert is finished with artistic presentation on plates, where I consider color, texture, and balance to create visually appealing creations.',
          'Furthermore, I am familiar with a wide range of pastry equipment such as mixers, ovens, piping bags, molds, and pastry brushes, and I am adept at employing different serving methods.',
          'Innovation is a key aspect of my approach—I have the ability to develop new pastry recipes while prioritizing quality and consistency. Importantly, I adhere to strict hygiene standards and prioritize safe food handling practices in the kitchen.'
        ],       
        SOFT:[
          'I thrive on creativity, constantly seeking new flavor combinations, innovative presentation techniques, and unique dessert concepts to delight customers and elevate their dining experience.',
          'The culinary world is dynamic and ever-evolving. I embrace change with enthusiasm, readily adapting to new trends, ingredients, and techniques to stay ahead of the curve and continuously improve my craft.',
          'Collaboration is key in a bustling kitchen environment. I excel in teamwork, communicating effectively with colleagues, sharing ideas, and working seamlessly together to achieve culinary excellence.',
          'Ultimately, my goal is to create memorable experiences for customers through my desserts. I listen attentively to customer feedback, striving to exceed their expectations and leave a lasting impression with every sweet creation.'
        ],
        LANGUAGE:'I have a passion for learning languages (lately Italian) and diving into programming with Python'       
      },
      CakeTypeNav:{
        CAKES:'Cakes',
        PLATED:'Plated Desserts',
        BONBON: 'BonBons and Cookies'
      }
    },
    ProductPage: {
      TITLE: "cakes"
    },
    Footer: {
      LETS:" Whether you just want to chat or have a brilliant idea brewing, feel free to reach out. Let's dive in and start the conversation!",
      SITEMAP: {
        TITLE: "sitemap",
        HOME: "home",
        PRODUCTS: "cakes"
      }
    }
  }
};
